import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "~/lib/utils";
import { useUser } from "~/modules/user/hooks/useUser";
import { ColumnSpanConfig } from "~/types";
import { useRegistrationModal } from "~/modules/auth/hooks/useRegistrationModal";

// // // //

// NOTE - is a 1-1 copy of src/components/TableCard
// Made a quick copy to adjust some of the spacing that didn't work well with the Top Transfers card
// We'll circle back later and consolidate back to the original component - for now to avoid unintended side effects
// of any CSS changes (specifically the mb-5 on the header div in the original TableCard) we're just going to
// make a copy so we can ship the TopTransfersCard to production
export function TableCard(props: {
    title: string;
    children: React.ReactNode;
    button?: React.ReactNode;
    bordered?: boolean;
    colSpans?: ColumnSpanConfig;
    loginConfig?: {
        required: boolean;
        analyticsLabel: string;
        analyticsEventProperties: Record<string, string>;
    };
}) {
    const {
        title,
        children,
        button = null,
        loginConfig,
        bordered = true,
        colSpans = {
            sm: 12,
            md: 12,
            lg: 12,
            xl: 8,
            xxl: 8,
        },
    } = props;

    // Flag whether or not to show the column
    const { isLoggedIn } = useUser();
    const { open: openRegistrationModal } = useRegistrationModal();
    const loginRequired = loginConfig?.required || false;
    const isContentLoginGated = loginRequired && !isLoggedIn;

    const smColSpan = colSpans.sm || 12;
    const mdColSpan = colSpans.md || 12;
    const lgColSpan = colSpans.lg || 12;
    const xlColSpan = colSpans.xl || 6;
    const xxlColSpan = colSpans.xxl || 6;

    return (
        <div
            className={cn(
                "pt-5 bg-card rounded-lg shadow-xs border overflow-clip",
                "flex flex-col justify-start",
                `col-span-12 sm:col-span-${smColSpan} md:col-span-${mdColSpan} lg:col-span-${lgColSpan} xl:col-span-${xlColSpan} 2xl:col-span-${xxlColSpan}`,
            )}
        >
            <div className="flex flex-col gap-2 mb-2 md:mb-5 md:flex-row md:justify-between md:items-center">
                <div className="w-full">
                    <p className="text-foreground text-xl leading px-5">
                        {title}
                    </p>
                </div>

                {button != null && <div className="px-5">{button}</div>}

                {isContentLoginGated && loginConfig != null && (
                    <div className="px-5">
                        <button
                            className="select-none text-sm flex items-center gap-1.5 font-semibold whitespace-nowrap w-fit mt-0.5 cursor-pointer text-link hover:text-link-hover transition-colors"
                            onClick={() => {
                                openRegistrationModal({
                                    label: loginConfig.analyticsLabel,
                                    properties:
                                        loginConfig.analyticsEventProperties,
                                });
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faLock}
                                className="h-2.5 w-2.5"
                            />
                            Log in to Unlock
                        </button>
                    </div>
                )}
            </div>

            <div className={cn("flex flex-col", bordered && "border-t")}>
                {children}
            </div>
        </div>
    );
}
